const DETAIL_PAGE_PATTERNS = [
  /^\/todo\/[^/]+$/,
  /^\/collab\/(?!leaderboard$)[^/]+$/,
  /^\/reminders\/(?!create$|add$)[^/]+$/,
  /^\/bookings\/(?!create$|add$)[^/]+$/,
  /^\/transactions\/(?!add$|create$)[^/]+$/,
  /^(?:\/(?:collab|listings|meetups|meetup-groups|todo|fundraise|bookings)\/[^/]+)?\/file-center\/[^/]+\/(?!chat-rooms$|messages$|activity-points$)[^/]+$/,
];

export function isDetailPageUrl(url: string): boolean {
  const path = url.split('?')[0].split('#')[0];
  return DETAIL_PAGE_PATTERNS.some(pattern => pattern.test(path));
}
